import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {
  findInHierarchyTab<T>(tab: T[], validator: (e: T) => boolean, childFieldName = ''): T {
    let result: T = tab.find(validator);
    if (result) {
      return result;
    }
    for (const element of tab) {
      if (childFieldName && element[childFieldName] && element[childFieldName] instanceof Array) {
        result = this.findInHierarchyTab(element[childFieldName], validator, childFieldName);
      }
      if (result) {
        return result;
      }
    }
    return result;
  }
}
